import AuthInitialState from "./authReducer/initialState";
import VehicleWiseCollectionInitialState from "./collectionReducer/initialState";
import CitiesInitialState from "./citiesReducer/initialState";
import OperatorsInitialState from "./operatorsReducer/initialState";
import CardCollectionInitialState from "./cardCollectionReducer/initialState";
import BreakDownInitialState from "./dayWiseBreakDownReducer/initialState";
import ContractedVehicleList from "./contractReducer/initialState";
import DateFilterState from "./dateFilterReducer/initialState";
import NotificationInitialState from "./notificationReducer/initialState";
import OperatorViewState from "./operatorViewReducer/initialState";
import SettlementState from "./settlementReducer/initialState";
import overviewInitialState from "./overviewReducer/initialState";
import OperatorTypeInitialState from "./operationTypeReducer/initialState";
import distanceReportState from "./distanceReportReducer/initialState";
import Expenses from "./expenseReducer/initialState";
import AdminConfig from "./adminConfigReducer/initialState";
import OperatorSettlementConfig from "./operatorSettlementConfigReducer";

const initialState = {
  Auth: AuthInitialState,
  VEHICLE_WISE_COLLECTION: VehicleWiseCollectionInitialState,
  CONTRACTED_VEHICLE_LIST: ContractedVehicleList,
  CITIES: CitiesInitialState,
  OPERATORS: OperatorsInitialState,
  CARD_COLLECTION: CardCollectionInitialState,
  DATE_FILTER: DateFilterState,
  BREAKDOWN: BreakDownInitialState,
  Notification: NotificationInitialState,
  Settlement: SettlementState,
  Overview: overviewInitialState,
  OperatorType: OperatorTypeInitialState,
  DistanceReport: distanceReportState,
  OperatorView: OperatorViewState,
  Expenses,
  AdminConfig,
  OperatorSettlementConfig,
};
export default initialState;
